import { render, staticRenderFns } from "./promoter_index.vue?vue&type=template&id=64406827&scoped=true&"
import script from "./promoter_index.vue?vue&type=script&lang=js&"
export * from "./promoter_index.vue?vue&type=script&lang=js&"
import style0 from "./promoter_index.vue?vue&type=style&index=0&id=64406827&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64406827",
  null
  
)

export default component.exports